/* eslint-disable jsx-a11y/anchor-is-valid */
import styled from 'styled-components';
import { FilterOutlined, ClearOutlined, MoreOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Tooltip, Typography, Row, Button } from 'antd';
import { Text } from 'atoms';
import { FormatDateTime } from './functions/formatDateTime';
import { getUserType } from 'hooks/useAuth';
import { PopoverWrapper, PopoverButton, UploadModal } from 'components';

const ActionButton = styled.button`
	border: none;
	background-color: transparent;
	&:hover {
		background-color: lightgray;
		cursor: pointer;
	}
`;
export function GenerateLRList({ gatherData, filters, colFilters, clearFilter }) {
	const navigate = useNavigate();
	return [
		{
			title: 'LR Number',
			dataIndex: 'id',
			key: 'id',
			hidden: false,
			render: (value, record) => (
				<>
					<Text overFlow="hidden">{`CSN${String(value).padStart(6, '0')}` || ''}</Text>
					<Button
						overFlow="hidden"
						style={{
							fontSize: '10px',
							border: 'none',
							backgroundColor: 'transparent',
							fontWeight: 'bold',
							marginLeft: '-10px',
							color: 'black',
						}}
						onClick={() => navigate(`/trips/${record.trip_id}/overview`)}
					>
						{`(Trip ID: ${record.trip_id})` || ''}
					</Button>
				</>
			),
		},
		// {
		// 	title: 'Client',
		// 	dataIndex: 'client_name',
		// 	key: 'client_name',
		// 	hidden: false,
		// 	width: 150,
		// 	ellipsis: true,
		// 	render: (value) => (
		// 		<Text overFlow="hidden">
		// 			<Typography.Text ellipsis={{ rows: 2, expandable: false, symbol: '...' }}>
		// 				{value || ''}
		// 			</Typography.Text>
		// 		</Text>
		// 	),
		// 	filters: filters.client_name?.map((item) => ({ text: item, value: item })),
		// 	filterIcon: <FilterOutlined />,
		// 	filtered: false,
		// 	onFilter: (value, record) => record.client_name.indexOf(value) === 0,
		// 	filterSearch: true,
		// },
		{
			title: (
				<Row justify="space-between" align="middle">
					<span>Project</span>
					{colFilters?.project?.length > 0 && (
						<Tooltip title="Clear Filter">
							<ClearOutlined
								onClick={() => clearFilter('project')}
								style={{ color: 'red' }}
							/>
						</Tooltip>
					)}
				</Row>
			),
			dataIndex: 'project',
			key: 'project',
			hidden: false,
			width: 150,
			ellipsis: true,
			render: (value) => (
				<Text overFlow="hidden">
					<Typography.Text ellipsis={{ symbol: '...' }}>{value || ''}</Typography.Text>
				</Text>
			),
			filteredValue: colFilters?.project || null,
			filters: filters.project?.map((item) => ({ text: item, value: item })),
			filterIcon: <FilterOutlined />,
			filtered: false,
			onFilter: (value, record) => record.project.indexOf(value) === 0,
			filterSearch: true,
		},
		{
			title: (
				<Row justify="space-between" align="middle">
					<span>Vendor</span>
					{colFilters?.vendor?.length > 0 && (
						<Tooltip title="Clear Filter">
							<ClearOutlined
								onClick={() => clearFilter('vendor')}
								style={{ color: 'red' }}
							/>
						</Tooltip>
					)}
				</Row>
			),
			dataIndex: 'vendor',
			key: 'vendor',
			hidden: false,
			width: 150,
			ellipsis: true,
			render: (value) => (
				<Text overFlow="hidden">
					<Typography.Text ellipsis={{ symbol: '...' }}>{value || ''}</Typography.Text>
				</Text>
			),
			filters: filters.vendor?.map((item) => ({ text: item, value: item })),
			filterIcon: <FilterOutlined />,
			filteredValue: colFilters.vendor || null,
			onFilter: (value, record) => record.vendor.indexOf(value) === 0,
			filterSearch: true,
		},
		{
			title: (
				<Row justify="space-between" align="middle">
					<span>Sender</span>
					{colFilters?.sender_name?.length > 0 && (
						<Tooltip title="Clear Filter">
							<ClearOutlined
								onClick={() => clearFilter('sender_name')}
								style={{ color: 'red' }}
							/>
						</Tooltip>
					)}
				</Row>
			),
			dataIndex: 'sender_name',
			key: 'sender_name',
			hidden: false,
			maxWidth: 150,
			width: 150,
			ellipsis: true,
			render: (value) => (
				<Text overFlow="hidden">
					<Typography.Text ellipsis={{ symbol: '...' }}>{value || ''}</Typography.Text>
				</Text>
			),
			filters: filters.sender_name?.map((item) => ({ text: item, value: item })),
			filterIcon: <FilterOutlined />,
			filteredValue: colFilters.sender_name || null,
			onFilter: (value, record) => record.sender_name.indexOf(value) === 0,
			filterSearch: true,
		},
		{
			title: (
				<Row justify="space-between" align="middle">
					<span>Receiver</span>
					{colFilters?.receiver_name?.length > 0 && (
						<Tooltip title="Clear Filter">
							<ClearOutlined
								onClick={() => clearFilter('receiver_name')}
								style={{ color: 'red' }}
							/>
						</Tooltip>
					)}
				</Row>
			),
			dataIndex: 'receiver_name',
			key: 'receiver_name',
			hidden: false,
			width: 200,
			ellipsis: true,
			render: (value) => (
				<Text overFlow="hidden">
					<Typography.Text ellipsis={{ symbol: '...' }}>{value || ''}</Typography.Text>
				</Text>
			),
			filters: filters.receiver_name?.map((item) => ({ text: item, value: item })),
			filterIcon: <FilterOutlined />,
			filteredValue: colFilters.receiver_name || null,
			onFilter: (value, record) => record.receiver_name.indexOf(value) === 0,
			filterSearch: true,
		},
		{
			title: (
				<Row justify="space-between" align="middle">
					<span>Source</span>
					{colFilters?.source_location?.length > 0 && (
						<Tooltip title="Clear Filter">
							<ClearOutlined
								onClick={() => clearFilter('source_location')}
								style={{ color: 'red' }}
							/>
						</Tooltip>
					)}
				</Row>
			),
			dataIndex: 'source_location',
			key: 'source_location',
			hidden: false,
			render: (value) => (
				<Text overFlow="hidden">
					<Typography.Text ellipsis={{ symbol: '...' }}>{value || ''}</Typography.Text>
				</Text>
			),
			filters: filters.source_location?.map((item) => ({ text: item, value: item })),
			filterIcon: <FilterOutlined />,
			onFilter: (value, record) => record.source_location.indexOf(value) === 0,
			filterSearch: true,
			filteredValue: colFilters.source_location || null,
		},
		{
			title: (
				<Row justify="space-between" align="middle">
					<span>Destination</span>
					{colFilters?.destination_location?.length > 0 && (
						<Tooltip title="Clear Filter">
							<ClearOutlined
								onClick={() => clearFilter('destination_location')}
								style={{ color: 'red' }}
							/>
						</Tooltip>
					)}
				</Row>
			),
			dataIndex: 'destination_location',
			key: 'destination_location',
			hidden: false,
			render: (value) => (
				<Text overFlow="hidden">
					<Typography.Text ellipsis={{ symbol: '...' }}>{value || ''}</Typography.Text>
				</Text>
			),
			filters: filters.destination_location?.map((item) => ({ text: item, value: item })),
			filterIcon: <FilterOutlined />,
			onFilter: (value, record) => record.destination_location.indexOf(value) === 0,
			filterSearch: true,
			filteredValue: colFilters.destination_location || null,
		},
		{
			title: 'Issue at',
			dataIndex: 'created_at',
			key: 'created_at',
			hidden: false,
			render: (value) => <Text overFlow="hidden">{<>{FormatDateTime(value)}</> || ''}</Text>,
		},
		{
			title: 'POD',
			dataIndex: 'pod_status',
			key: 'pod_status',
			hidden: false,
			render: (value) => <Text>{value || '-'}</Text>,
		},
		{
			title: 'Action',
			dataIndex: 'id',
			align: 'center',
			key: 'id',
			hidden: false,
			render: (id, record) => (
				// <Space size="middle" wrap>
				// 	{!record.soft_delete && (
				// 		<Link to={`/lr/${id}?isEdit=false`}>
				// 			<EyeOutlined
				// 				style={{
				// 					fontSize: '20px',
				// 				}}
				// 			/>
				// 		</Link>
				// 	)}

				// 	<Tooltip title="Download LR">
				// 		<FilePdfOutlined
				// 			style={{
				// 				color: 'red',
				// 				fontSize: '20px',
				// 			}}
				// 			onClick={() => gatherData(id, 'download')}
				// 		/>
				// 	</Tooltip>
				// 	<Tooltip title="Print LR">
				// 		<PrinterOutlined
				// 			style={{
				// 				color: 'blue',
				// 				fontSize: '20px',
				// 			}}
				// 			onClick={() => gatherData(id, 'print')}
				// 		/>
				// 	</Tooltip>
				// 	{!record.soft_delete &&
				// 		['admin', 'supervisor', 'city_manager'].includes(getUserType()) && (
				// 			<Tooltip title="Cancel LR">
				// 				<CloseCircleOutlined
				// 					style={{
				// 						color: 'red',
				// 						fontSize: '20px',
				// 					}}
				// 					onClick={() => gatherData(id, 'cancel')}
				// 				/>
				// 			</Tooltip>
				// 		)}
				// </Space>
				<PopoverWrapper
					content={
						<div style={{ maxWidth: '130px' }}>
							<PopoverButton textAlign="left" onClick={() => gatherData(id, 'print')}>
								Print
							</PopoverButton>
							<PopoverButton
								textAlign="left"
								onClick={() => gatherData(id, 'download')}
							>
								Download
							</PopoverButton>
							{!record.soft_delete && (
								<PopoverButton
									textAlign="left"
									onClick={() => gatherData(id, 'view')}
								>
									View
								</PopoverButton>
							)}
							{!record.soft_delete &&
								['admin', 'supervisor', 'city_manager'].includes(getUserType()) && (
									<PopoverButton
										textAlign="left"
										color="red"
										onClick={() => gatherData(id, 'cancel')}
									>
										Cancel LR
									</PopoverButton>
								)}
							<UploadModal
								tripId={record.trip_id}
								consignmentId={id}
								disabled={
									record.trip_status !== 3 ||
									record.trip_end_km === 0 ||
									record.pod_status === 'Pending' ||
									record.pod_status === 'Accepted'
								}
							/>
						</div>
					}
				>
					<ActionButton type="button">
						<MoreOutlined />
					</ActionButton>
				</PopoverWrapper>
			),
		},
	];
}

GenerateLRList.propTypes = {
	gatherData: PropTypes.func,
	filters: PropTypes.object,
};
